import { StaticCanvas, Canvas as FabricCanvas } from 'fabric';

function disposeCanvas(canvas: FabricCanvas | StaticCanvas) {
  // trick for safari to reduce the canvas size/memory
  canvas.setDimensions({ width: 1, height: 1 });
  void canvas.dispose().then(() => {});
}

export default disposeCanvas;
